import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";
import { SEO } from "@/components/seo/SEO";

export default function Termos() {
  return (
    <Layout>
      <SEO path="/termos" title="Termos de Uso — Cogni" description="Termos de uso dos serviços da plataforma Cogni de gestão de créditos de energia." />
      <PageHero
        title="Termos de Uso"
        subtitle="Última atualização: [Data]"
        variant="gradient"
      />

      <section className="section-padding section-alt">
        <div className="container-narrow">
          <div className="bg-background rounded-xl sm:rounded-2xl border border-border p-5 sm:p-8 md:p-12 shadow-lg">
            <div className="prose prose-sm sm:prose-base lg:prose-lg max-w-none prose-headings:text-foreground prose-p:text-muted-foreground prose-li:text-muted-foreground prose-strong:text-foreground">
              <h2>1. Aceitação dos Termos</h2>
              <p>
                Ao acessar ou usar os serviços da Cogni, você concorda em cumprir estes 
                Termos de Uso. Se você não concordar com qualquer parte destes termos, 
                não deve usar nossos serviços.
              </p>

              <h2>2. Descrição dos Serviços</h2>
              <p>
                A Cogni oferece uma plataforma de gestão de créditos de energia distribuída, 
                incluindo funcionalidades de:
              </p>
              <ul>
                <li>Importação e gestão de faturas de energia</li>
                <li>Cálculo e distribuição de rateios de créditos</li>
                <li>Emissão de cobranças (boletos e PIX)</li>
                <li>Portal do consumidor para acompanhamento</li>
                <li>Relatórios e analytics</li>
              </ul>

              <h2>3. Cadastro e Conta</h2>
              <p>
                Para usar nossos serviços, você deve criar uma conta fornecendo informações 
                precisas e completas. Você é responsável por manter a confidencialidade de 
                suas credenciais de acesso.
              </p>

              <h2>4. Uso Aceitável</h2>
              <p>Você concorda em não:</p>
              <ul>
                <li>Usar os serviços para fins ilegais ou não autorizados</li>
                <li>Tentar acessar áreas restritas do sistema</li>
                <li>Transmitir vírus ou código malicioso</li>
                <li>Interferir no funcionamento dos serviços</li>
                <li>Copiar ou redistribuir o software sem autorização</li>
              </ul>

              <h2>5. Propriedade Intelectual</h2>
              <p>
                Todo o conteúdo, software, design e marcas associados à Cogni são de 
                propriedade exclusiva da Cogni ou seus licenciadores. O uso dos serviços 
                não transfere nenhum direito de propriedade intelectual.
              </p>

              <h2>6. Dados e Privacidade</h2>
              <p>
                O tratamento de dados pessoais é regido por nossa Política de Privacidade. 
                Você é responsável pelos dados que insere na plataforma e declara ter os 
                direitos necessários para processá-los.
              </p>

              <h2>7. Pagamentos e Cancelamento</h2>
              <p>
                Os valores e condições de pagamento são definidos no contrato de assinatura. 
                O cancelamento pode ser solicitado a qualquer momento, com efeito no próximo 
                ciclo de faturamento.
              </p>

              <h2>8. Disponibilidade do Serviço</h2>
              <p>
                Nos esforçamos para manter os serviços disponíveis 24/7, mas não garantimos 
                disponibilidade ininterrupta. Manutenções programadas serão comunicadas com 
                antecedência.
              </p>

              <h2>9. Limitação de Responsabilidade</h2>
              <p>
                A Cogni não será responsável por danos indiretos, incidentais ou 
                consequenciais decorrentes do uso dos serviços. Nossa responsabilidade 
                máxima está limitada ao valor pago nos últimos 12 meses.
              </p>

              <h2>10. Indenização</h2>
              <p>
                Você concorda em indenizar a Cogni por quaisquer perdas decorrentes do 
                seu uso indevido dos serviços ou violação destes termos.
              </p>

              <h2>11. Modificações</h2>
              <p>
                Podemos modificar estes termos a qualquer momento. Alterações significativas 
                serão notificadas com 30 dias de antecedência. O uso continuado após as 
                alterações constitui aceitação dos novos termos.
              </p>

              <h2>12. Lei Aplicável</h2>
              <p>
                Estes termos são regidos pelas leis do Brasil. Qualquer disputa será 
                resolvida no foro da comarca de São Paulo, SP.
              </p>

              <h2>13. Contato</h2>
              <p>
                Para dúvidas sobre estes termos, entre em contato:
              </p>
              <p>
                <strong>E-mail:</strong> juridico@cogni.com.br<br />
                <strong>Endereço:</strong> [Endereço completo]
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
